export const TYPE_INDIVIDUAL = "individual" as const;
export const TYPE_GROUP = "group" as const;

export const SCORECARD_STATUS_APPROVED = 2;
